import { ITransform } from '../../../../models/ITransform';

export function getTransformTextRepresentation(transform: ITransform) {
    let result = '';

    result += 'Top Instruction\n';
    result += transform?.header?.prompt?.value || '-';
    result += '\n';
    result += 'Formats\n';
    result += `Input (${transform?.header?.input?.format})\n`;
    result += `Query (${transform?.header?.query?.format})\n`;
    result += `Instruction\n`;
    result += `Result (${transform?.header?.result?.format})\n`;
    result += `\n`;
    result += `Rows count: ${transform?.rows?.length}\n`;

    for (let i = 0; i < transform?.rows?.length; i++) {
        const row = transform?.rows[i];
        const rowInfo = `(row #${i + 1})`;
        result += `Input ${rowInfo}:\n`;
        result += `${row.input || '-'}\n`;
        result += `Query ${rowInfo}:\n`;
        result += `${row.query || '-'}\n`;
        result += `Instruction ${rowInfo}:\n`;
        result += `${row.prompt}\n`;
        result += `Result ${rowInfo}:\n`;
        result += `${row.result}\n`;
    }

    return result;
}